// === CUSTOM: Checkout Timer Script – Cart & Cart Drawer (aus altem Theme übernommen) ===
// Countdown über dem "Zur Kasse"-Button mit Warnung in letzten 30 Sekunden

document.addEventListener('DOMContentLoaded', function () {
  let timerDisplay = document.getElementById('checkout-timer-countdown');
  if (!timerDisplay) return;

  let interval;
  let timeLeft = 300;

  function startTimer() {
    clearInterval(interval);
    timeLeft = 300;
    updateDisplay();

    interval = setInterval(() => {
      if (timeLeft <= 0) {
        clearInterval(interval);
        timerDisplay.textContent = 'abgelaufen';
        timerDisplay.classList.remove('urgent');
        return;
      }

      if (timeLeft <= 30) {
        timerDisplay.classList.add('urgent');
      } else {
        timerDisplay.classList.remove('urgent');
      }

      updateDisplay();
      timeLeft--;
    }, 1000);
  }

  function updateDisplay() {
    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;
    timerDisplay.textContent =
      minutes > 0
        ? `${minutes}:${seconds.toString().padStart(2, '0')} Minuten`
        : `${seconds} Sekunden`;
  }

  // Timer beim Laden starten
  startTimer();

  // Timer neu starten bei Änderungen im Warenkorb
  document.addEventListener('cart:updated', function () {
    startTimer();
  });
});
